module.exports = __webpack_public_path__ + "colorpicker_light_material.f5e61701eff1981f29cd.png";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/colorpicker_light_material.png
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/colorpicker_light_material.png
// module chunks = 2